import { format, getMonth } from 'date-fns';
import { ru } from 'date-fns/locale/ru';

const UTCShortFormat = 'yyyy-MM-dd';

export const formatDate = (dateVal: Date | string | number, dateFormat = UTCShortFormat) =>
  format(new Date(dateVal), dateFormat, { locale: ru });

/**
 * Сокращаем длинные месяца до трех букв без точки, март, май, июнь, июль оставляем как есть.
 *
 * @param val дата
 * @param dateFormat
 */
export const calendarFormatMonths = (val: number | string | Date, dateFormat = 'd MMMM yyyy') => {
  const date = new Date(val);
  const formattedDate = formatDate(date, dateFormat);
  switch (getMonth(date)) {
    case 2:
    case 4:
    case 5:
    case 6:
      return formattedDate;
    default: {
      // после локализации месяца с 4-мя буквами сокращаем до трех и удаляем точку в конце
      const arrFormStr = formattedDate.split(' ');

      arrFormStr[0] = arrFormStr[0].slice(0, 3);
      return arrFormStr.join(' ');
    }
  }
};

export const readingTime = (count: number) => {
  const time = Math.round(count / 60);

  return `Читать ${time}&nbsp;мин`;
};

export const getNumberOfDaysDiff = (start: number | string | Date, end: number | string | Date) => {
  const startDate = new Date(start);
  const finishDate = new Date(end);

  const oneDay = 1000 * 60 * 60 * 24;
  const diffInTime = finishDate.getTime() - startDate.getTime();

  return Math.round(diffInTime / oneDay);
};
